import router from '../../router'
import Message_TemplateService from '../../services/WA_Message_TemplateService'

const state = () => ({
    loadingMessage_Templates: false,
    message_template: null,
    message_templates: [],
    total: 0,
    pages: 0,
    page: 1,
    never_synced: false,
    syncing_templates: false,
    show_modal_new_message_template: false,
    // Catálogo das variáveis locais (GET /whatsapp_message_template/variables)
    variable_catalog: [],
    variable_catalog_loaded: false,
})

const mutations = {
    SET_MESSAGE_TEMPLATE: (state, payload) => {
        state.message_template = payload
    },
    SET_MESSAGE_TEMPLATES: (state, payload) => {
        if(payload.pageNumber == 1) {
            state.message_templates = payload.itens
        }else{
            state.message_templates = [...state.message_templates, ...payload.itens]
        }
        state.page =  payload.pageNumber
        state.pages =  payload.pages
        state.total =  payload.total
        state.never_synced = Boolean(payload.neverSynced)
    },
    SET_LOADING_MESSAGE_TEMPLATES: (state, payload) => {
        state.loadingMessage_Template = payload
    },
    SET_SYNCING_TEMPLATES: (state, payload) => {
        state.syncing_templates = payload
    },
    SET_SHOW_MODAL_MESSAGE_TEMPLATE: (state, payload) => {
        state.show_modal_new_message_template = payload
    },
    SET_WA_VARIABLE_CATALOG: (state, payload) => {
        state.variable_catalog = Array.isArray(payload) ? payload : []
        state.variable_catalog_loaded = true
    },
    // Atualização pontual vinda do socket (wa:template-updated) — mantém a
    // listagem e o modal de envio em dia sem recarregar
    PATCH_MESSAGE_TEMPLATE: (state, payload) => {
        if (!payload) return
        const item = state.message_templates.find(t => (payload.id && t.id === payload.id)
            || (t.name === payload.name && t.language === payload.language))
        if (!item) return
        const FIELDS = ['status', 'category', 'rejection_reason', 'quality_score', 'last_synced_at', 'meta_template_id']
        FIELDS.forEach(f => { if (payload[f] !== undefined) item[f] = payload[f] })
    },
}

const actions = {
    // Catálogo das variáveis locais — carrega uma vez; silencioso em erro
    // (o formulário continua funcionando só com "Campo livre")
    async fetchWaVariableCatalog({commit, state}, { force = false } = {}){
        if (state.variable_catalog_loaded && !force) return state.variable_catalog;
        try{
            const response = await Message_TemplateService.variables();
            commit('SET_WA_VARIABLE_CATALOG', response.data?.itens || [])
        } catch (error) {
            commit('SET_WA_VARIABLE_CATALOG', [])
        }
        return state.variable_catalog;
    },
    // Mídia de exemplo do cabeçalho → { handle, format, previewUrl } ou null
    async uploadTemplateSample({commit}, file){
        try{
            const response = await Message_TemplateService.uploadSample(file);
            return response.data;
        } catch (error) {
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.error || error.response?.data?.message || 'Falha ao enviar a mídia de exemplo.'
            });
            return null;
        }
    },
    async fetchMessage_Template({commit}, id){
        try{
            commit('SET_LOADING_MESSAGE_TEMPLATES', true)
            const response = await Message_TemplateService.getOne(id);
            commit('SET_MESSAGE_TEMPLATE', response.data)
            commit('SET_LOADING_MESSAGE_TEMPLATES', false)
        } catch (error) {
            commit('SET_LOADING_MESSAGE_TEMPLATES', false);
            if(error && error.response && error.response.data.message == "Sessão expirada") {
                commit('SET_REDIRECT', router.currentRoute.value.path);
                commit('LOG_USER_OUT');
            }
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.message || 'Falha ao carregar o template.'
            });
        }
    },
    async fetchMessage_Templates({commit}, params = {}){
        try{
            commit('SET_LOADING_MESSAGE_TEMPLATES', true)
            const { keyword = '', pageNumber = 1, pageSize = 12, order = { name: 'ID', column: 'ID', sort: 'ASC' }, status = '', category = '' } = params;
            const response = await Message_TemplateService.get(keyword, pageNumber, pageSize, order, status, category);
            commit('SET_MESSAGE_TEMPLATES', response.data)
            commit('SET_LOADING_MESSAGE_TEMPLATES', false)
        } catch (error) {
            commit('SET_LOADING_MESSAGE_TEMPLATES', false);
            if(error && error.response && error.response.data.message == "Sessão expirada") {
                commit('SET_REDIRECT', router.currentRoute.value.path);
                commit('LOG_USER_OUT');
            }
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.message || 'Falha ao carregar os templates.'
            });
        }
    },
    // Sincroniza os templates da conta Meta do tenant e recarrega a listagem
    async syncMessage_Templates({commit, dispatch}){
        try{
            commit('SET_SYNCING_TEMPLATES', true)
            const response = await Message_TemplateService.sync();
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });
            await dispatch('fetchMessage_Templates', { pageNumber: 1 });
        } catch (error) {
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.error || error.response?.data?.message || 'Falha ao sincronizar com a Meta.'
            });
        } finally {
            commit('SET_SYNCING_TEMPLATES', false)
        }
    },
    // Cria um template na Meta (fica PENDING até a aprovação via webhook)
    async createMessage_Template({commit, dispatch}, payload){
        try{
            const response = await Message_TemplateService.create(payload);
            commit('SET_ALERT', { heading: 'success', message: response.data.message });
            await dispatch('fetchMessage_Templates', { pageNumber: 1 });
            return true;
        } catch (error) {
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.errors?.join(' | ') || error.response?.data?.error || error.response?.data?.message || 'Falha ao criar o template.'
            });
            return false;
        }
    },
    // Edita um template na Meta (volta a PENDING; limite da Meta: 1x/24h p/ aprovados)
    async updateMessage_Template({commit, dispatch}, { id, ...payload }){
        try{
            const response = await Message_TemplateService.update(id, payload);
            commit('SET_ALERT', { heading: 'success', message: response.data.message });
            await dispatch('fetchMessage_Templates', { pageNumber: 1 });
            return true;
        } catch (error) {
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.errors?.join(' | ') || error.response?.data?.error || error.response?.data?.message || 'Falha ao editar o template.'
            });
            return false;
        }
    },
    // Exclui um template na Meta (e do cache local)
    async deleteMessage_Template({commit, dispatch}, id){
        try{
            const response = await Message_TemplateService.remove(id);
            commit('SET_ALERT', { heading: 'success', message: response.data.message });
            await dispatch('fetchMessage_Templates', { pageNumber: 1 });
            return true;
        } catch (error) {
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.error || error.response?.data?.message || 'Falha ao excluir o template.'
            });
            return false;
        }
    },
    // Pré-valida valores contra a estrutura do template (retorna {valid, errors, components})
    async validateMessage_Template({commit}, { templateId, values }){
        try{
            const response = await Message_TemplateService.validate(templateId, values);
            return response.data;
        } catch (error) {
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.message || 'Falha ao validar o template.'
            });
            return { valid: false, errors: ['Falha na validação.'] };
        }
    },
}

const getters = {
    getMessage_Template: state => state.message_template,
    getMessage_Templates: state => state.message_templates,
    getLoadingMessage_Template: state => state.loadingMessage_Template,
    getSyncingTemplates: state => state.syncing_templates,
    getNeverSyncedTemplates: state => state.never_synced,
    getShowModalNewMessage_Template: state => state.show_modal_new_message_template,
    getWaVariableCatalog: state => state.variable_catalog,
}

export default {
    state,
    getters,
    mutations,
    actions
};
